import { ControlGroup, Tag } from "@blueprintjs/core";
import { FGCustomInput, IFGFormGroupProps } from "nsitools-react";
import * as React from "react";
import styled from "styled-components";
import { FGHourInput } from ".";
import { useCommonHooks } from "../../hooks";
import { ETLCodes } from "../../locales";

export interface IFGHourIntervalProps
  extends Omit<IFGFormGroupProps, "children"> {
  hourFromName: string;
  hourToName: string;
}

const StyledTag = styled(Tag)`
  margin-top: 5px;
`;

const InnerLabelContainer = styled.div`
  display: flex;
  align-items: baseline;
  justify-content: center;
`;

export const FGHourInterval: React.FunctionComponent<IFGHourIntervalProps> = ({
  label,
  hourFromName,
  hourToName,
  ...props
}) => {
  const { t } = useCommonHooks();
  return (
    <FGCustomInput label={label}>
      {({ formik }) => (
        <ControlGroup fill>
          <FGHourInput noLabel name={hourFromName} {...props} />
          <InnerLabelContainer>
            <StyledTag round>{t(ETLCodes.To_Hour)}</StyledTag>
          </InnerLabelContainer>
          <FGHourInput noLabel name={hourToName} {...props} />
        </ControlGroup>
      )}
    </FGCustomInput>
  );
};
